import { Modal, Form, Input } from 'antd'
import React from 'react'
import PropTypes from 'prop-types'
import toClass from 'recompose/toClass'

const FormItem = Form.Item
const { TextArea } = Input

const AWSCredentialsComponent = props => {
  const { form, editingRecord, ...rest } = props
  const { getFieldDecorator } = form

  return (
    <Modal
      {...rest}
      centered
      title="Change the AWS credentials"
      okText="Change"
    >
      <Form layout="vertical">
        <FormItem label="Access Key">
          {getFieldDecorator('accessKeyId', {
            rules: [
              {
                required: true
              }
            ]
          })(<Input />)}
        </FormItem>
        <FormItem label="Secret Access Key">
          {getFieldDecorator('secretAccessKey', {
            rules: [
              {
                required: true
              }
            ]
          })(<Input />)}
        </FormItem>
        <FormItem label="Session Token">
          {getFieldDecorator('sessionToken', {
            rules: [
              {
                required: true
              }
            ]
          })(<TextArea rows={6} />)}
        </FormItem>
      </Form>
    </Modal>
  )
}

export const AWSCredentialsModal = Form.create({
  mapPropsToFields: ({ record }) =>
    Object.keys(record).reduce(
      (xs, x) => ({ ...xs, [x]: Form.createFormField({ value: record[x] }) }),
      {}
    )
})(toClass(AWSCredentialsComponent))

AWSCredentialsComponent.propTypes = {
  record: PropTypes.object,
  form: PropTypes.any,
  editingRecord: PropTypes.object,
  type: PropTypes.string
}
